module.exports = __webpack_public_path__ + "static/media/Hover_D2_Poker.c16032b1.png";